import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { BadgeComponent } from '../../shared';
import { Environment, PackageName } from '../types';
import { exploreProductList, productList } from './config';
import { MyProductsComponent } from './my-products/my-products.component';
import { ExploreProductsComponent } from './explore-products/explore-products.component';
@Component({
    standalone: true,
    templateUrl: 'product-card.component.html',
    selector: 'global-home-product-card',
    imports: [CommonModule, MyProductsComponent, ExploreProductsComponent, BadgeComponent],
    styleUrls: ['../../styles.scss', './product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class ProductCardComponent {
    @Input() packageName!: PackageName | null;

    @Input() exploreProductIds!: string[] | null;

    @Input() accessProductList!: string[] | null;

    @Input() consumerResearchUrl!: string | null;

    @Input() environment!: Environment | null;

    get myProducts() {
        return productList.filter(({ id }) => this.accessProductList?.includes(id));
    }

    get exploreProducts() {
        return exploreProductList.filter(({ id }) => this.exploreProductIds?.includes(id));
    }
}
